'use strict';

/* global reloadCart, refreshStageFormTokens, storage, GoogleTagManager */

import $ from 'jquery';
import Mustache from 'mustache';
import * as cart from '../api/cart';
import utils from '../util';
import { setAbVariant } from '../util/ab-testing';
import Promise from 'bluebird';
import {slideDown, slideUp} from '../ui/slide';
import _throttle from 'lodash/throttle';
import {GoogleTagManager} from '../misc/ga-events';

import { Toggle } from '../ui/toggle';
import breakpoints from '../ui/breakpoints';

const $document = $(document);
const $html = $('html');
const headerCart = {};
let cartData = {};

let cartTemplate;
let cartItemTemplate;
let cartPackageItemTemplate;
let cartSingleItemTemplate;

let $cartItemOverlayActions;

let $headerCartMobileContainer;
let $headerMiniCartContainer;
let $headerCartsContainer;

let $headerCart;
let $cartItemOverlay;

let $cartCount;
let overlayTimer;
let toggle;

let miniCart;
let cartItemCount = 0;

const setCartOverlayHidden = () => {
	$cartItemOverlay.addClass('collapsed');
	$cartItemOverlayActions.attr('tabindex', -1);
	$cartItemOverlay.removeClass('fixed');
	$html.removeClass('v4-header-cart-open v4-header-cart-closing');
}

// Hide "new item added" cart overlay
const hideCartOverlay = () => {
	if ($html.hasClass('v4-header-cart-open')) {
		$html.addClass('v4-header-cart-closing');
		setTimeout(() => {
			setCartOverlayHidden();
		}, 500);
	}
}

// Mouse event listeners for for overlay
const addMouseOverEvents = () => {
	// New item added cart overlay timeout
	$headerCartsContainer.on('mouseenter', () => {
		clearTimeout(overlayTimer);
	}).on('mouseleave', () => {
		overlayTimer = setTimeout(() => {
			hideCartOverlay();
		}, 400);
	});
}

// Remove event listeners
const removeMouseOverEvents = () => {
	$headerCartsContainer.off('mouseenter').off('mouseleave');
}

// Mini cart toggle is shown
const onToggleShow = () => {
	clearTimeout(overlayTimer);
	setCartOverlayHidden();
}

headerCart.init = function() {
	$cartCount = $('.js-cart-count');
	cartItemCount = parseInt($cartCount.text());
	cartTemplate = $('#v4-template-cart').html();
	cartItemTemplate = $('#v4-template-cart-item').html();
	cartPackageItemTemplate = $('#v4-template-cart-item-package').html();
	cartSingleItemTemplate = $('#v4-template-cart-item-single').html();

	$headerCartsContainer = $('.js-header-carts');
	$headerMiniCartContainer = $headerCartsContainer.find('.js-toggle-cart');

	$headerCart = $headerMiniCartContainer.find('.v4-header-cart');
	$cartItemOverlay = $headerCartsContainer.find('.cart-item-overlay');
	$cartItemOverlayActions = $cartItemOverlay.find('button, a');

	$headerCartMobileContainer = $('.v4-header-cart-mobile-container');

	if (window.location.hash.indexOf('#cart') > -1) {
		cart.flushLocalCart();
		history.replaceState(null, '', location.pathname + location.search); // remove url hash
	}

	this.updateHeaderCart();
	$cartItemOverlayActions.attr('tabindex', -1);

	// Create toggle for mini shopping cart
	miniCart = document.getElementById('mini-cart');
	toggle = new Toggle(miniCart, {
		activeClass: 'm-navigation-actions__dropdown--open',
		toggleOnHover: true,
		useBreakpoints: true,
		enabledBreakpoints: ['desktop'],
		autoClose: true,
		enableCheck: (() => !!cartItemCount > 0),
		onEnable: (() => addMouseOverEvents()),
		onDisable: (() => removeMouseOverEvents()),
		onShow: (() => onToggleShow())
	});

	// Remove items via header cart
	$document.on('click', '.v4-header-cart-items-list-item-remove', function(e) {
		const itemData = $(this).closest('.v4-header-cart-items-list-item').data();

		!isTouch() ? addLoader($headerCart, 'v4-header-cart-loader') : addLoader($headerCartMobileContainer.find('.v4-header-cart'), 'v4-header-cart-loader');

		cart.removeItem(itemData.id).then(response => {
			if (response && response.result === 1) {
				headerCart.updateHeaderCart(true, response.cart, true);

				GoogleTagManager.removeFromCart(
					itemData.sapTitlenumber,
					itemData.ean.toString(),
					itemData.amount,
					itemData.color,
					itemData.productName,
					itemData.brandName,
					itemData.categoryPath,
					itemData.sportsNames,
					itemData.targetgroup,
					itemData.fullCategoryPath,
					itemData.salesPrice,
					itemData.sale_product
				);

			}
			return true;
		}).finally(() => {
			!isTouch() ? removeLoader($headerCart, 'v4-header-cart-loader') : removeLoader($headerCartMobileContainer.find('.v4-header-cart'), 'v4-header-cart-loader');
		});

		e.preventDefault();
	});

	// Close mobile header cart
	$document.on('click', '.v4-header-cart-close', function(e) {
		hideCartOverlay();
		e.preventDefault();
	});

	//'Jatka ostoksia'-link only closes minicart
	$document.on('click', '#close-minicart', (e) => {
		hideCartOverlay();
		e.preventDefault();
	})
};

/**
 * Helper function for showAddedItem function. Creates markup for added package item.
 *
 * @param {Object} cartData
 * @param {Object} addedItem
 * @return {string} package cartItem markup
 */
const createPackageItemMarkup = (cartData, addedItem) => {
	const singlePackage = addedItem.productPackage.type === 'single';
	const packageProducts = addedItem.products.filter(product => !product.isVirtual).map(product => {
		const productNameSuffix = product.productNameSuffix.length ? `-${product.productNameSuffix.join(' ')}` : '';
		const sizeLabel = product.sizeLabel ? product.sizeLabel : product.size ? product.size : null;
		return Object.assign(product, { productNameSuffix: productNameSuffix, sizeLabel: sizeLabel })
	});
	cartData.singlePackage = singlePackage;
	cartData.packageProducts = packageProducts;

	return Mustache.render(cartItemTemplate, cartData, { packageItem: cartPackageItemTemplate });
}

/**
 * Helper function for showAddedItem function. Creates markup for added single item.
 *
 * @param {*} cartData
 * @param {*} addedItem
 * @return {string} single cartItem markup
 */
const createSingleItemMarkup = (cartData, addedItem) => {
	const singleProduct = addedItem.products[0];
	const productNameSuffix = singleProduct.productNameSuffix.length ? `-${singleProduct.productNameSuffix.join(' ')}` : '';
	const sizeLabel = singleProduct.sizeLabel ? singleProduct.sizeLabel : singleProduct.size ? singleProduct.size : null;
	singleProduct.productNameSuffix = productNameSuffix;
	singleProduct.sizeLabel = sizeLabel;
	cartData.singleProduct = singleProduct;

	return Mustache.render(cartItemTemplate, cartData, { singleItem: cartSingleItemTemplate });
}

/**
 * Displays a new cart item as toast element.
 *
 * @param {Object} data - response from ajax call
 */
const showAddedItem = (cartData, latestItemId) => {
	let markup;
	const headerCartRightOffset = 26; //$(window).width() - ($cartItemOverlay.offset().left + $cartItemOverlay.outerWidth());
	const scrolledOver = $(window).scrollTop() >= 70;
	const addedItem = cartData.reservedItems.filter(item => item.id === latestItemId)[0];
	const isPackage = (typeof addedItem.packageId !== 'undefined' && addedItem.packageId);
	cartData.isPackage = isPackage;
	cartData.addedItem = addedItem;

	/**
   * Add debounced scroll event listener for fixed cart item.
   * item. Places cart item to original position when window is scrolled to top.
   */
	const scrollHandler = () => {
		const headerCartContainerBottom = $headerMiniCartContainer.offset().top + $headerMiniCartContainer.outerHeight(true);
		$(window).on('scroll', _throttle(() => {
			const $height = $(window).scrollTop();
			if ($height <= headerCartContainerBottom) {
				$cartItemOverlay.removeClass('fixed');
				$cartItemOverlay.css('right', '');
			}
		}, 100))
	}

	if (isPackage) {
		markup = createPackageItemMarkup(cartData, addedItem);
	} else {
		markup = createSingleItemMarkup(cartData, addedItem);
	}

	$html.addClass('v4-header-cart-open');

	$cartItemOverlay.replaceWith(markup);
	scrolledOver ? $headerCartsContainer.find('.cart-item-overlay').css('right', headerCartRightOffset) : null;
	$cartItemOverlay = $headerCartsContainer.find('.cart-item-overlay');

	if (scrolledOver) {
		scrollHandler()
	}

	setTimeout(() => {
		$cartItemOverlayActions.attr('tabindex', 0);
		slideDown($cartItemOverlay);
		if (scrolledOver) {
			$cartItemOverlay.addClass('fixed');
		}

		// A11y requires to set focus to first element of dialog
		setTimeout(() => {
			$cartItemOverlayActions[0].focus();
		}, 500);
	}, 100);

	let timer = isPackage ? 10000 : 5000;

	clearTimeout(overlayTimer);

	if (['small','medium'].includes(breakpoints.getBreakpoint('precise'))) {
		return;
	}

	overlayTimer = setTimeout(() => {
		slideUp($cartItemOverlay);
		hideCartOverlay();
	}, timer);
}

export const updateHeaderCart = (flashPopup, data, itemRemoved = false, latestItemId = null) => {
	const cartPromise = data ? Promise.resolve({ cart: data }) : cart.getCart();
	//const AbTestVersion = getCurrentVariant('minicart2019');
	const AbTestVersion = 'new';

	cartPromise.then(function(response) {
		cartData = response.cart;

		// never render unavailable items in header cart
		cartData.reservedItems = cartData.reservedItems.filter(item => !item.unavailable);

		//$cartPrice.html(cartData.totals.price + ' &euro;');
		$cartCount.text(cartData.itemCount);
		cartItemCount = cartData.itemCount;

		$html.removeClass('v4-header-cart-open');

		const markup = Mustache.render(cartTemplate, cartData);

		$headerCart.replaceWith(markup);
		AbTestVersion !== 'new' ? $headerCartMobileContainer.find('.v4-header-cart').replaceWith(markup) : null;
		$headerCart = $headerCartsContainer.find('.v4-header-cart');

		// Enable minicart in desktop if there is products
		if (cartItemCount > 0 && breakpoints.getBreakpoint() === 'desktop') {
			toggle.enable();
		} else {
			toggle.disable();
		}

		utils.addObjectFitPolyfill();

		if (flashPopup && cartData.reservedItems.length) {
			if (!itemRemoved) {
				showAddedItem(cartData, latestItemId)
			}
		}
	}).catch((error) => {
		console.log(JSON.stringify(error));
	});
}
headerCart.updateHeaderCart = updateHeaderCart;

headerCart.forceNewCart = () => {
	setAbVariant('purchaseFunnel', 'new', 14);
	$('.header-cart-link').attr('href', $headerCart.data('cart-url'));
}

export default headerCart;

/**
 * Add loader to container
 */
function addLoader($container, cssClass) {
	removeLoader($container, cssClass);

	$container.addClass('is-loading');

	$('<div>', { class: cssClass })
		.append($('<div>', { class: 'spinner-loader-circle' }))
		.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle2' }))
		.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle3' }))
		.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle4' }))
		.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle5' }))
		.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle6' }))
		.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle7' }))
		.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle8' }))
		.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle9' }))
		.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle10' }))
		.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle11' }))
		.append($('<div>', { class: 'spinner-loader-circle spinner-loader-circle12' }))
		.appendTo($container);
}

/**
 * Remove loader from container
 */
function removeLoader($container, cssClass) {
	$container.find(`.${cssClass}`).remove();
	$container.removeClass('is-loading');
}

/**
 * Is touch (mobile or tablet)
 */
function isTouch() {
	return $(window).width() < 1024;
}
